import permissions from 'constants/permissions'

const JURIDIC_TICKET_LIST = [
  {
    name: 'Visualizar',
    tag: permissions.JURIDIC_TICKET.VIEW,
  },
  {
    name: 'Gerenciar',
    tag: permissions.JURIDIC_TICKET.MANAGE,
  },
]

export default JURIDIC_TICKET_LIST
